module.exports = __webpack_public_path__ + "img/logo_color.be580ba6.png";